import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { escapeHtml } from './mailUi';

// The message's own HTML in a sealed frame: no script runs in it, links open in a new tab.
export default function Body({ html, text, confirmLinks }) {
  const ref = useRef(null);
  const [h, setH] = useState(200);
  const doc = useMemo(() => {
    const content = html != null ? html : `<pre>${escapeHtml(text || '')}</pre>`;
    return `<!doctype html><html><head><meta charset="utf-8"><base target="_blank"><style>
      html,body{margin:0;background:#fff}body{padding:16px 24px 28px;font-family:'Segoe UI',-apple-system,BlinkMacSystemFont,Roboto,Arial,sans-serif;font-size:14px;line-height:1.5;color:#201f1e;overflow-wrap:anywhere}
      img{max-width:100%;height:auto}table{max-width:100%}pre{white-space:pre-wrap;font-family:inherit;margin:0}a{color:#0f6cbd}blockquote{margin:0 0 0 .4em;padding-left:.8em;border-left:3px solid #e1dfdd;color:#484644}
    </style></head><body>${content}</body></html>`;
  }, [html, text]);
  const measure = useCallback(() => {
    const d = ref.current && ref.current.contentDocument;
    if (d && d.documentElement) setH(Math.max(120, d.documentElement.scrollHeight));
  }, []);
  useEffect(() => {
    const f = ref.current;
    if (!f) return undefined;
    let ro;
    const onLoad = () => {
      measure();
      const d = f.contentDocument;
      if (!d) return;
      d.querySelectorAll('img').forEach((img) => img.addEventListener('load', measure));
      // "Check links before they open": show where a link really goes, and ask.
      if (confirmLinks) {
        d.addEventListener('click', (e) => {
          const a = e.target && e.target.closest && e.target.closest('a[href]');
          if (!a) return;
          const href = a.getAttribute('href') || '';
          if (/^mailto:/i.test(href)) return;
          if (!window.confirm(`This link goes to:\n\n${href}\n\nOpen it?`)) e.preventDefault();
        });
      }
      if (window.ResizeObserver && d.body) { ro = new ResizeObserver(measure); ro.observe(d.body); }
    };
    f.addEventListener('load', onLoad);
    return () => { f.removeEventListener('load', onLoad); if (ro) ro.disconnect(); };
  }, [doc, measure, confirmLinks]);
  return (
    <iframe ref={ref} title="Message" srcDoc={doc} style={{ height: h }} className="block w-full border-0"
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals" referrerPolicy="no-referrer" />
  );
}
